import Vue from 'vue'
import App from './App.vue'
// 按需引入DataV
import dataV from "./dataV"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/index'
import router from "./router"
import './utils/mixin.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// resetcss
import '../static/css/reset.css';
import "@/plugin/uni.webview.1.5.6";

import 'vant/lib/index.css';
// 常用css
import '../static/css/main.css';
import scanner from './utils/install';
// 配置NProgress进度条选项  —— 动画效果
NProgress.configure({
    easing: 'ease',  // 动画方式
    speed: 500,  // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3 // 初始化时的最小百分比
})

Vue.prototype.$store = store
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(scanner);
Vue.use(dataV)

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
